import {TagType, entities} from '../../../util/uiconstants';
import {currentResource} from '../../../util/utils';
export const SampleItemFilterConfiguration = {
	tags: {
		endpoint: 'tags',
		entityFilter: (entityFilters) => ({
			engagementId: entityFilters.engagementId,
			entityId: entities.SampleItem,
			filterTagCategory: TagType.FilteringNotArchived
		}),
		entityMapping: (response) => {
			const tags = response?.data
				?.filter((x) => x.engagementTagId)
				.sort(function (a, b) {
					return (
						(a.engagementTagGroupName ?? '').localeCompare(b.engagementTagGroupName ?? '') ||
						(a.engagementTagName ?? '').localeCompare(b.engagementTagName ?? '')
					);
				})
				.map((item) => ({
					value: '#' + item.engagementTagId.toString(),
					label: item.engagementTagName,
					group: item.engagementTagGroupName
				}));

			return tags;
		},
		getDisplayValue: (id, entityType, _filterData) => {
			let value;

			if (_filterData?.store && _filterData?.store[entityType].byId && _filterData?.store[entityType].byId[id]) {
				value = _filterData?.store[entityType]?.byId[id].label;
			}

			return value;
		}
	}
};

export const ControlFilterConfiguration = {
	controls: {
		endpoint: 'controls',
		entityMapping: (response) => {
			return response?.data
				.sort((a, b) => a.controlName.localeCompare(b.controlName))
				.map((item) => ({
					value: item.id.toString(),
					label: item.controlName
				}));
		},
		getDisplayValue: (id, entityType, _filterData) => {
			return _filterData?.store[entityType]?.byId[id]?.label;
		}
	},
	rommTypes: {
		getDisplayValue: (value) => {
			const options = currentResource.labels?.controlIdentifyControls?.rommTypeFilterOptions;
			return options?.find((item) => String(item.value) === String(value))?.label;
		}
	},
	filterHasAnyRiskRequiredControls: {
		getDisplayValue: (value) => {
			return currentResource.yesNoOptions.find((item) => Boolean(item.value) === value)?.label;
		}
	}
};

export const ITApplicationsFilterConfiguration = {
	itApplications: {
		endpoint: 'itapplications',
		entityMapping: (response) => {
			const list = Array.isArray(response) ? response : (response?.data ?? []);
			return list
				.filter((item) => !item.isDeleted)
				.map((item) => ({
					value: String(item.id),
					label: item.itApplicationName
				}))
				.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
		},
		getDisplayValue: (id, _entityType, filterData) => filterData?.byId?.[String(id)]?.label
	}
};

export const EngagementUsersFilterConfiguration = {
	engagementUsers: {
		endpoint: 'InternalUsers',
		entityMapping: (response) => {
			const users = response?.data ?? response?.users ?? [];
			return users
				.map((user) => ({
					value: String(user?.userId ?? user.gui),
					label: `${user.firstName} ${user.lastName}`
				}))
				.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
		},
		getDisplayValue: (id, _entityType, filterData) => filterData?.byId?.[String(id)]?.label
	}
};

export const AccountsFilterEntityConfiguration = {
	accounts: {
		endpoint: 'Accounts',
		entityMapping: (response) => {
			const list = Array.isArray(response) ? response : (response?.data ?? []);
			return list.map(({id, accountName}) => ({value: String(id), label: accountName})).sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
		}
	}
};

export const EntitiesFilterEntityConfiguration = {
	entities: {
		endpoint: 'multiEntity',
		entityMapping: (response) => {
			const list = Array.isArray(response) ? response : (response?.data ?? []);
			return list
				.filter((entity) => !entity.isDeleted)
				.map(({id, stEntityName}) => ({value: String(id), label: stEntityName}))
				.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
		}
	}
};

export const ComponentsFilterEntityConfiguration = {
	components: {
		endpoint: 'GroupComponents',
		entityMapping: (response) => {
			const list = Array.isArray(response) ? response : (response?.value?.data ?? response?.data ?? []);
			return list
				.filter((component) => !component?.isDeleted)
				.map(({gaComponentId, shortName}) => ({value: String(gaComponentId), label: shortName}))
				.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? '', undefined, {numeric: true, sensitivity: 'base'}));
		}
	}
};

export const DeficiencyTagsFilterEntityConfiguration = {
	deficiencyTags: {
		endpoint: 'tags',
		entityMapping: (response) => {
			return (response?.data ?? [])
				.filter((x) => x.engagementTagId)
				.map((item) => ({
					value: String(item.engagementTagId),
					label: item.engagementTagName
				}))
				.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
		}
	}
};

export const FilterEntityConfiguration = {
	...SampleItemFilterConfiguration,
	...ControlFilterConfiguration,
	...AccountsFilterEntityConfiguration,
	...ITApplicationsFilterConfiguration,
	...EngagementUsersFilterConfiguration,
	...EntitiesFilterEntityConfiguration,
	...ComponentsFilterEntityConfiguration,
	...DeficiencyTagsFilterEntityConfiguration
};
